import { useState } from 'react'

export const TABS = [
  { label: 'Vietnam Lotto', value: 'vietnam-lotto' },
  { label: 'Recommended', value: 'recommended' },
  { label: 'Highlights', value: 'highlights' },
  { label: 'Thai Stock Lotto', value: 'thai-stock-lotto' },
  { label: 'International Lotto', value: 'international-lotto' },
  { label: 'Group Lotto', value: 'group-lotto' },
]

export const useSelectionTabs = (initialTabs: string[] = []) => {
  const [selectedTabs, setSelectedTabs] = useState<string[]>(initialTabs)

  const toggleTab = (tab: string): void => {
    if (selectedTabs.includes(tab)) {
      setSelectedTabs(selectedTabs.filter((t) => t !== tab)) // Deselect
    } else {
      setSelectedTabs([...selectedTabs, tab]) // Select
    }
  }
  const clearAll = () => {
    setSelectedTabs([])
  }

  return {
    setSelectedTabs,
    selectedTabs,
    toggleTab,
    clearAll,
  }
}
